// extracted by css-extract-rspack-plugin
export default {"item":"_183a24a5"};